import React, {Component} from 'react';
import {ShipContext} from './context/ShipContext';
import HotspotOnCloseupImage from './HotspotOnCloseupImage';

export class CloseupArea extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isHoveringOverOtherHotspots: false
        };

        this.mouseLeaveTimeoutId = 0;
        this.handleMouseEnterOnHotspot = this.handleMouseEnterOnHotspot.bind(this);
        this.handleMouseLeaveFromHotspot = this.handleMouseLeaveFromHotspot.bind(this);
    }

    handleMouseEnterOnHotspot() {
        clearTimeout(this.mouseLeaveTimeoutId);
        this.setState({isHoveringOverOtherHotspots: true});
    }

    handleMouseLeaveFromHotspot(hotspotIsActive) {
        if (hotspotIsActive) {
            this.setState({isHoveringOverOtherHotspots: false});
        } else {
            // Delay the action not to show active hotspot too quickly
            const delayTime = 700;
            this.mouseLeaveTimeoutId = setTimeout(() => {
                this.setState({isHoveringOverOtherHotspots: false});
            }, delayTime);
        }
    }

    render() {
        const {
            engineRoomImgUrl,
            closeupAreaSubareas,
            activeAreaId,
            areaId
        } = this.props;

        const hotspots = closeupAreaSubareas.map((area) =>
            <HotspotOnCloseupImage
                key={area.id}
                areaName={area.name}
                areaId={area.id}
                hotspotLabelText={area.displayName}
                isHoveringOverOtherHotspots={this.state.isHoveringOverOtherHotspots}
                handleMouseEnterOnHotspot={this.handleMouseEnterOnHotspot}
                handleMouseLeaveFromHotspot={this.handleMouseLeaveFromHotspot}
            />
        );

        let styles;
        if (activeAreaId === areaId) {
            styles = {
                opacity: 1,
                visibility: 'visible',
                pointerEvents: 'auto'
            }
        } else {
            styles = {
                pointerEvents: 'none'
            };
        }

        return (
            <div
                className="ships-viewer__interior js-ship-interior"
                style={styles}
            >
                <img src={engineRoomImgUrl}/>
                {hotspots}
            </div>
        )
    }
}

function CloseupAreaWithContext(props) {
    return (
        <ShipContext.Consumer>
            {(context) =>
                <CloseupArea
                    activeAreaId={context.activeAreaId}
                    {...props}
                />
            }
        </ShipContext.Consumer>
    )
}

export default CloseupAreaWithContext;

